import { render } from "./TopHeadlinesTable.vue?vue&type=template&id=4e8c51ee"
import script from "./TopHeadlinesTable.vue?vue&type=script&lang=js"
export * from "./TopHeadlinesTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__